var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "subscriber") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.0000302%",
    cy: "50.0000302%",
    fx: "50.0000302%",
    fy: "50.0000302%",
    r: "51.6167849%",
    id: "subscriber-radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA300",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscriber",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0284,2.91378 L16.2357,0.667951 C16.1573,0.445558 15.8427,0.445558 15.7643,0.667951 L14.9716,2.91378 C12.9003,8.78263 8.78263,12.9003 2.91378,14.9716 L0.667951,15.7643 C0.445558,15.8427 0.445558,16.1573 0.667951,16.2357 L2.91378,17.0284 C8.78263,19.0998 12.9003,23.2174 14.9716,29.0862 L15.7643,31.3321 C15.8427,31.5544 16.1573,31.5544 16.2357,31.3321 L17.0284,29.0862 C19.0998,23.2174 23.2174,19.0998 29.0862,17.0284 L31.3321,16.2357 C31.5544,16.1573 31.5544,15.8427 31.3321,15.7643 L29.0862,14.9716 C23.2174,12.9003 19.0998,8.78263 17.0284,2.91378 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0284,2.91378 L16.2357,0.667951 C16.1573,0.445558 15.8427,0.445558 15.7643,0.667951 L14.9716,2.91378 C12.9003,8.78263 8.78263,12.9003 2.91378,14.9716 L0.667951,15.7643 C0.445558,15.8427 0.445558,16.1573 0.667951,16.2357 L2.91378,17.0284 C8.78263,19.0998 12.9003,23.2174 14.9716,29.0862 L15.7643,31.3321 C15.8427,31.5544 16.1573,31.5544 16.2357,31.3321 L17.0284,29.0862 C19.0998,23.2174 23.2174,19.0998 29.0862,17.0284 L31.3321,16.2357 C31.5544,16.1573 31.5544,15.8427 31.3321,15.7643 L29.0862,14.9716 C23.2174,12.9003 19.0998,8.78263 17.0284,2.91378 Z",
    id: "Path",
    fill: "url(#subscriber-radialGradient-1)",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriber);
export default __webpack_public_path__ + "static/media/subscriber.477cf1cf0392899ab2f9961c26be7b3e.svg";
export { ForwardRef as ReactComponent };